import type { getRentalDeviceInfo_rental_stocklistItem_deviceInfo } from 'Constants/graphql/queries/detail/__generated__/getRentalDeviceInfo'

export type DeviceInfo = getRentalDeviceInfo_rental_stocklistItem_deviceInfo

export enum DeviceHealthStatus {
  Healthy = 'healthy',
  Attention = 'attention',
}
